const EUROPEAN_AWAY_COMPETITIONS = new Set([
  'Champions League',
  'UEFA Europa League',
  'UEFA Europa Conference League',
]);

function isCoppaItaliaFinal(ticket) {
  if (!ticket || ticket.competition !== 'Coppa Italia') return false;
  const title = String(ticket.matchTitle || '').toLowerCase();
  return /\bfinale\b|\bfinal\b|\bfinali\b/.test(title);
}

export function requiresTravelInformationForm(ticket) {
  if (!ticket || ticket.isHome !== false) return false;
  if (ticket.competition === 'Coppa Italia' || isCoppaItaliaFinal(ticket)) return false;
  return EUROPEAN_AWAY_COMPETITIONS.has(ticket.competition);
}
